// extracted by mini-css-extract-plugin
module.exports = {"textArea":"ggo-try_textArea__aTzJk","container":"ggo-try_container__6lKE0"};